exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_object-pie.js
// module id = 42
// module chunks = 0